var Account, Breadcrumbs, GalleryPhotoPage, HeadingBar, NoAccount, Page, PhotoDetails, PhotoInfo, PhotoNavBar, m;

m = require('mithril');

Account = require('../../state/Account');

Page = require('../components/Page');

NoAccount = require('../components/NoAccount');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

PhotoNavBar = require('../components/PhotoNavBar');

PhotoDetails = require('../components/PhotoDetails');

PhotoInfo = require('../components/PhotoInfo');

GalleryPhotoPage = {
  controller: function(args) {
    var ctrl;
    ctrl = this;
    return ctrl;
  },
  view: function(ctrl, args) {
    var account, currentIndex, gallery, highestIndex, navArgs, next, photo, prev;
    account = args.account();
    if (account == null) {
      return m(NoAccount);
    }
    gallery = args.gallery();
    photo = args.photo();
    navArgs = {};
    navArgs.current = {
      label: photo.name
    };
    currentIndex = gallery.photos.indexOf(photo);
    highestIndex = gallery.photos.length - 1;
    if (currentIndex > 0) {
      prev = gallery.photos[currentIndex - 1];
    }
    if (currentIndex < highestIndex) {
      next = gallery.photos[currentIndex + 1];
    }
    if (prev != null) {
      navArgs.prev = {
        onclick: function() {
          return m.route("/gallery/" + gallery.id + "/photos/" + prev.name);
        }
      };
    }
    if (next != null) {
      navArgs.next = {
        onclick: function() {
          return m.route("/gallery/" + gallery.id + "/photos/" + next.name);
        }
      };
    }
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'gallery',
                content: gallery.name,
                onclick: function() {
                  return m.route("/gallery/" + gallery.id + "/thumbs");
                }
              }, {
                icon: 'image'
              }
            ]
          })
        }), m(PhotoNavBar, navArgs), m(PhotoDetails, {
          photo: photo
        }), m(PhotoInfo, {
          photo: photo
        })
      ]
    });
  }
};

module.exports = function(store) {
  return m(GalleryPhotoPage, {
    account: function() {
      return store.getState().account;
    },
    gallery: function() {
      var galleries, galleryId;
      galleryId = m.route.param().galleryId;
      galleries = store.getState().galleries;
      return Account.getGallery(galleries, galleryId);
    },
    photo: function() {
      var galleries, galleryId, photoName, ref;
      ref = m.route.param(), galleryId = ref.galleryId, photoName = ref.photoName;
      galleries = store.getState().galleries;
      return Account.getPhoto(galleries, galleryId, photoName);
    }
  });
};

//# sourceMappingURL=data:application/json;base64,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
